Vue.component('vq-textarea', {
  delimiters: ['[[', ']]'],
  inject: ['$validator'],
  props: {
    label: String,
    labelClasses: String,
    classes: String,
    model: Object,
    name: String,
    readOnly: {
      type: Boolean,
      default: false,
    },
    optional: {
      type: Boolean,
      default: false,
    },
    validate: {
      type: String,
      default: 'required'
    },
    validateName: String,
    validation: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    sync_model: {
      get() {
        return this.model.value
      },
      set(val) {
        this.$emit('update:model', { value: val })
      }
    },
    sync_validate() {
      if (this.optional && this.validate == 'required') {
        return '';
      } else if (!this.optional && this.validate != 'required') {
        return 'required|' + this.validate;
      } else {
        return this.validate;
      }
    },
    sync_validateName() {
      if (!this.validateName && this.label) {
        return this.label;
      } else {
        return this.validateName;
      }
    }
  },
  watch: {
    model: {
      immediate: true,
      handler() {
        if (!this.model.hasOwnProperty('value') || this.model.value == null) {
          this.sync_model = '';
        }

        if (this.errors.has(this.name) || (this.fields.hasOwnProperty(this.name) && this.fields[this.name].dirty && this.model.value != '')) {
          this.$validator.validate(this.name);
        }
      }
    }
  },
  methods: {
    classesValidation() {
      if (this.validation && !this.readOnly) {
        return {
          'is-valid': !this.errors.has(this.name) && this.fields[this.name] && this.fields[this.name].valid && this.model.value != '',
          'is-error': this.errors.has(this.name)
        }
      }
    },
    reset() {
      this.sync_model = '';
      this.$refs.field.focus();
    }
  },
  mounted() {
    if (this.model.value) {
      this.$validator.validate(this.name);
    }
  },
  template: `<div class="form-control" :class="[classesValidation(), {'has-validation': validation, 'is-read-only': readOnly}]">
	<label class="label pb-5" :class="labelClasses" :for="name" v-if="label">[[label]]</label>
	<div class="wrapper" :class="{'is-resetable': !readOnly, 'is-empty' : model.value == ''}">
		<span class="is-optional" v-if="optional">optionnel</span>
		<textarea ref="field" class="textarea" :class="classes" v-model="sync_model" v-validate="sync_validate"
			:data-vv-as="sync_validateName" data-vv-validate-on="blur" :name="name" :id="name"></textarea>
		<button type="button" class="reset" @click="reset" v-if="!readOnly && model.value != ''" tabindex="-1"></button>
	</div>
</div>`
})